import { useState } from "react";
import { colorPickerSelector } from "store/features/colorPicker/selectors/colorPickerSelector";
import { ColorPickerState } from "store/features/colorPicker/types";
import { useAppSelector } from "store/store";
import type Swiper from "swiper";

export const colorSchemes = ["complementary", "triadic", "tetradic", "analogous", "monoChromatic"] as const;
export type ColorScheme = (typeof colorSchemes)[number];

const defaultColorScheme: ColorScheme = "analogous";
export const initialSlide = colorSchemes.indexOf(defaultColorScheme);

export const useColorHarmonies = () => {
    const { selectedColor } = useAppSelector(colorPickerSelector, equalityFn);
    const [tab, _setTab] = useState<ColorScheme>(defaultColorScheme);
    const [swiper, setSwiper] = useState<Swiper | null>(null);
    const setTab = (tab: ColorScheme) => {
        const index = colorSchemes.indexOf(tab);
        if (index >= 0 && swiper) swiper.slideTo(index);
        _setTab(tab);
    };
    return { tab, setTab, selectedColor, swiper, setSwiper };
};

const equalityFn = (left: ColorPickerState, right: ColorPickerState) => {
    if (JSON.stringify(left.selectedColor) !== JSON.stringify(right.selectedColor)) return false;
    return true;
};
